"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userExternalAccountsController = function () {
  function userExternalAccountsController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userExternalAccountsController);
  }

  (0, _createClass3.default)(userExternalAccountsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.externalAccounts,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No External Accounts."
        },
        columns: [{ field: "name", title: "Name", filterable: false, width: "6rem" }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getAccountType(dataItem.accountType);
          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "creationDate", title: "Creation Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(creationDate), 'dd/MM/yyyy')#" }]
      };
    }
  }, {
    key: "_getAccountType",
    value: function _getAccountType(type) {
      switch (type) {
        case _constants2.default.externalAccountType.FACEBOOK:
          return "Facebook";
        case _constants2.default.externalAccountType.LINKEDIN:
          return "LinkedIn";
      }
    }
  }]);
  return userExternalAccountsController;
}();

exports.default = userExternalAccountsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-external-accounts/user-external-accounts.controller.js
 **/